import { render, staticRenderFns } from "./KeyboardShortcutsContainer.vue?vue&type=template&id=fc34a3f2&scoped=true&"
import script from "./KeyboardShortcutsContainer.vue?vue&type=script&lang=js&"
export * from "./KeyboardShortcutsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc34a3f2",
  null
  
)

export default component.exports